import { UserRole, usePossibleUser } from '@/hooks/useProfile';
import { PropsWithChildren } from 'react';

interface RoleProps {
  admin?: boolean;
  industry?: boolean;
  supplier?: boolean;
  readOnlyAdmin?: boolean;
  customer?: boolean;
  loggedIn?: boolean;
  employee?: boolean;
  employeeAdmin?: boolean;
  except?: UserRole[];
}

export const Role = ({
  admin = false,
  industry = false,
  supplier = false,
  readOnlyAdmin = false,
  customer = false,
  loggedIn = false,
  employee = false,
  employeeAdmin = false,
  except = [],
  children
}: PropsWithChildren<RoleProps>) => {
  const user = usePossibleUser();
  const role = user?.role;

  const show = except.length
    ? role && !except.includes(role)
    : [
        readOnlyAdmin && role === 'read_only_admin',
        admin && role === 'admin',
        supplier && role === 'supplier',
        industry && role === 'industry',
        customer && role === 'customer',
        employee && role === 'employee',
        employeeAdmin && user?.permissions?.has('admin'),
        loggedIn && role
      ].some(Boolean);

  if (show) {
    return <>{children}</>;
  }

  return null;
};
